import defaultReplication from '@/rxdb/defaultReplication';
import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';

export const weatherIssues = {
    schema: {
        title: 'weatherIssues schema',
        version: 2,
        description: 'describes a weatherIssues',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: {
                type: 'string',
                final: true,
                maxLength: 40,
            },
            projectId: {
                type: ['string', 'null'],
            },
            name: {
                type: ['string', 'null'],
            },
            date: {
                type: ['string', 'null'],
            },
            duration: {
                type: ['number', 'null'],
            },
            conclusion: {
                type: ['string', 'null'],
            },
            conclusionComment: {
                type: ['string', 'null'],
            },
            emitterIds: {
                type: ['array', 'null'],
                items: { type: 'string' },
            },
            attachments: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                    properties: {
                        url: { type: 'string' },
                        fileName: { type: 'string' },
                    },
                },
            },
            createdBy: {
                type: ['string', 'null'],
            },
            updatedAt: {
                type: ['string', 'null'],
            },
            deletedAt: {
                type: ['string', 'null'],
            },
            deletedBy: {
                type: ['string', 'null'],
            },
            createdAt: {
                type: ['string', 'null'],
            },
            updatedBy: {
                type: ['string', 'null'],
            },
            rootVersion: {
                type: ['string', 'null'],
            },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: function (oldDoc) {
            return oldDoc;
        },
        2: function (oldDoc) {
            if (oldDoc.isValidated) {
                oldDoc.conclusion = 'validated';
            }
            delete oldDoc.isValidated;
            return oldDoc;
        },
    },
};
